import './StepIndicator.css';

interface Step {
  num: 1 | 2 | 3 | 4 | 5 | 6;
  label: string;
}

interface Props {
  steps: Step[];
  currentStep: 1 | 2 | 3 | 4 | 5 | 6;
  onStepClick?: (step: 1 | 2 | 3 | 4 | 5 | 6) => void;
}

export default function StepIndicator({ steps, currentStep, onStepClick }: Props) {
  return (
    <div className="step-indicator">
      <div className="steps-container">
        {steps.map((s, idx) => {
          const isCompleted = s.num < currentStep;
          const isCurrent = s.num === currentStep;
          const isClickable = isCompleted;

          return (
            <div key={s.num} className="step-item">
              <button
                className={`step-dot ${isCurrent ? 'current' : isCompleted ? 'completed' : ''}`}
                onClick={() => isClickable && onStepClick?.(s.num)}
                disabled={!isClickable}
                type="button"
                aria-label={`Step ${s.num}: ${s.label}`}
              >
                {s.num}
              </button>
              {idx < steps.length - 1 && (
                <div className={`step-line ${isCompleted ? 'completed' : ''}`} />
              )}
            </div>
          );
        })}
      </div>
      <div className="step-label">
        {steps.find(s => s.num === currentStep)?.label}
      </div>
    </div>
  );
}
